import React, {Component} from 'react';
import {Row, Col} from "reactstrap";
import './HowItsWork.scss'
import webConfig from '../../config/WebConfig'
import main1 from '../../assets/img/revamp/edulab/See-how-it-works.jpg'
import sub1 from '../../assets/img/revamp/edulab/Class Recordings.png'
import sub2 from '../../assets/img/revamp/edulab/Online Exams.png'
import sub3 from '../../assets/img/revamp/edulab/Online Payments.png'
import sub4 from '../../assets/img/revamp/edulab/Share Learning Materials.png'
import {isMobile} from "react-device-detect";

class HowItsWork extends Component {

    render() {
        let {desc, descSin} = this.props;
        return (
            <div className="container how-its-work pt-3 pb-6 ">
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <div className='text-center'>
                            <h1 className='main-topic'>
                                Learning is Simple with CJ Maths
                            </h1>
                            <p className='py-4 how-its-work-para mb-0'>{desc}</p>
                            {descSin && <p className={'py-4 how-its-work-para'}>{descSin}</p>}
                        </div>
                    </Col>
                </Row>

                <Row className='mt-3'>
                    <Col xs={12} sm={12} md={6} lg={6}>
                        <img className={'main-img'} width='100%' src={main1} alt=""/>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6}>
                        <Row>
                            <Col xs={12} sm={12} md={6} lg={6}> <img
                                className={`w-100 sub-img-contain ${isMobile ? 'mob-mt-10' : ''}`} src={sub1} alt=""/> </Col>
                            <Col xs={12} sm={12} md={6} lg={6}> <img
                                className={`w-100 sub-img-contain ${isMobile ? 'mob-mt-10' : ''}`} src={sub2} alt=""/> </Col>
                            <Col xs={12} sm={12} md={6} lg={6}> <img
                                className={`w-100 sub-img-contain ${isMobile ? 'mob-mt-10' : ''}`} src={sub3} alt=""/> </Col>
                            <Col xs={12} sm={12} md={6} lg={6}> <img
                                className={`w-100 sub-img-contain ${isMobile ? 'mob-mt-10' : ''}`} src={sub4} alt=""/> </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default HowItsWork;
